export function initialsOf(name: string) {
	return name
		.split(" ")
		.filter(Boolean)
		.slice(0, 2)
		.map((part) => part[0])
		.join("")
		.toUpperCase();
}

export function hueOf(name: string) {
	const sum = [...name].reduce((acc, char) => acc + char.charCodeAt(0), 0);
	return (sum * 37) % 360;
}

export function avatarGradient(name: string) {
	const hue = hueOf(name);
	return `linear-gradient(135deg, hsl(${hue} 70% 55%), hsl(${(hue + 30) % 360} 70% 40%))`;
}
